import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";
import { getImage } from "gatsby-plugin-image";
import { convertToBgImage } from "gbimage-bridge";
import { Container, Row, Col } from "@ui/wrapper";
import ConsultForm from "@components/forms/consult-form";
import Anchor from "@ui/anchor";
import Text from "@ui/text";
import LocationButton from "@ui/location-button";
import { SectionTitleType, HeadingType, TextType } from "@utils/types";
import {
    ContactWrapper,
    ContactInfoBox,
    StyledTitle,
    StyledPhone,
} from "./style";
import Image from "../../../components/ui/image";
import SectionTitle from "../../../components/ui/section-title";

const ContactArea = ({ id, data }) => {
    const contactBg = useStaticQuery(graphql`
        query ContactQuery {
            file(relativePath: { eq: "bg/contact-bg.jpg" }) {
                childImageSharp {
                    gatsbyImageData(
                        layout: FULL_WIDTH
                        placeholder: TRACED_SVG
                        formats: WEBP
                        quality: 100
                    )
                }
            }
        }
    `);
    const bgImage = convertToBgImage(getImage(contactBg.file));
    return (
        <ContactWrapper id={id} {...bgImage}>
            <Container>
                {data?.section_title && (
                    <SectionTitle
                        mb={["30px", null, "53px"]}
                        layout={2}
                        textAlign="left"
                        title={data.section_title?.title}
                        subtitle={data.section_title?.subtitle}
                        titleStyle={{ color: "#ffffff" }}
                        subtitleStyle={{ color: "#ffffff" }}
                    />
                )}
                <Row>
                    <Col lg={6}>
                        <ConsultForm />
                    </Col>
                    <Col lg={5} ml="auto">
                        <ContactInfoBox>
                            {data?.headings?.[0] && (
                                <StyledTitle as={data.headings[0].level}>
                                    {data.headings[0].content}
                                </StyledTitle>
                            )}
                            {data?.headings?.[1] && (
                                <StyledPhone as={data.headings[1].level}>
                                    <Anchor
                                        target="_blank"
                                        path="https://wa.me/+51985669265"
                                        $hover={{ layout: 2, color: "#16efff" }}
                                    >
                                        {data.headings[1].content}
                                    </Anchor>
                                </StyledPhone>
                            )}
                            {data?.texts?.[0] && (
                                <Text style={{ color: "#ffffff" }}>
                                    {data.texts[0].content}
                                </Text>
                            )}
                            {/*<LocationButton mt="20px" />*/}
                            <a
                                target="_blank"
                                href={"https://goo.gl/maps/52x7ij2FRrrcb1yS8"}
                            >
                                <Image src={data.images[0].src} alt="Map" />
                            </a>
                        </ContactInfoBox>
                    </Col>
                </Row>
            </Container>
        </ContactWrapper>
    );
};

ContactArea.propTypes = {
    id: PropTypes.string,
    data: PropTypes.shape({
        section_title: PropTypes.shape(SectionTitleType),
        headings: PropTypes.arrayOf(PropTypes.shape(HeadingType)),
        texts: PropTypes.arrayOf(PropTypes.shape(TextType)),
    }),
};

export default ContactArea;
